export function animateCancel() {
  $('html,body').on('mousewheel touchstart orientationchange', function() {
    $('html,body').stop();
  });
}